import { Col, Row } from 'react-bootstrap';
import { Card, ListContainer, ListItem } from 'shared/components';
import { PBody } from 'shared/components/Fonts';
import {
  ButtonPlaceholder,
  InputPlaceholder,
  TablePlaceholder,
  TextPlaceholder,
} from 'shared/placeholders';
import { messages } from './Message';
import { Table } from 'shared/table';

export const CostCentreMovePageSkeleton = () => {
  return (
    <>
      {/* Datos del centro de costos */}
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Title>Datos del Centro de Costos</Card.Title>
            <Card.Body className="p-3">
              <Row>
                <Col md={6}>
                  <TextPlaceholder />
                </Col>
                <Col md={6}>
                  <TextPlaceholder />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Reglas */}
      <Row className="mb-3">
        <Col>
          <Card variant="info">
            <Card.Body $spacing>
              <PBody className="fw-semibold">
                Antes de mover el centro de costos, tenga en cuenta lo siguiente:
              </PBody>
              <ListContainer>
                {messages.rules.map((rule) => (
                  <ListItem key={rule}>{rule}</ListItem>
                ))}
              </ListContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tarjetas */}
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Title>Tarjetas con Saldo</Card.Title>
            <Card.Body>
              <Table
                thead={
                  <tr>
                    <th>Número de Tarjeta</th>
                    <th>Denominación</th>
                    <th>Cuenta</th>
                    <th>Centro costo asociado</th>
                  </tr>
                }
                tbody={<TablePlaceholder cols={4} rows={5} />}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Centros de costos */}
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Title>Centros de costos con Saldo</Card.Title>
            <Card.Body>
              <Table
                thead={
                  <tr>
                    <th>Denominación</th>
                    <th>Cuenta</th>
                    <th>Depende de</th>
                  </tr>
                }
                tbody={<TablePlaceholder cols={3} rows={5} />}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Form */}
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Title>Asociar a nuevo centro de costos</Card.Title>
            <Card.Body $padding>
              <InputPlaceholder />
              <div className="mt-4 text-end">
                <ButtonPlaceholder>Mover</ButtonPlaceholder>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
